import React, { memo, useCallback, useState } from 'react'

import { Button, TextInput } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func } from 'prop-types'

function PasteUrlArea({ isLoading, onPasteUrlUpload: handlePasteUrlUpload }) {
  const [url, setUrl] = useState('')

  const handleUploadImageClick = useCallback(() => {
    handlePasteUrlUpload(url).then((success) => {
      if (success) {
        setUrl('')
      }
    })
  }, [url, handlePasteUrlUpload])

  const handleUrlChange = useCallback((e) => {
    setUrl(e.target.value)
  }, [setUrl])

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleUploadImageClick()
    }
  }, [handleUploadImageClick])

  return (
    <div className="image-uploader__paste-url-area">
      <TextInput
        id="paste-url-input"
        isPilot
        size="small"
        placeholder="Image URL"
        value={url}
        onChange={handleUrlChange}
        onKeyDown={handleKeyDown}
        isDisabled={isLoading}
      />
      <Button
        type="secondary"
        size="tiny"
        customClass="image-uploader__button"
        onClick={handleUploadImageClick}
        disabled={isLoading || !url.trim()}
      >
        Upload image
      </Button>
    </div>
  )
}

PasteUrlArea.propTypes = {
  isLoading: bool.isRequired,
  onPasteUrlUpload: func.isRequired,
}

export default memo(PasteUrlArea)
